const googleNewsStorage = 'GoogleNewsSubscribed';
const googleNewsPopUpClosed = 'GoogleNewsClosed';

var GoogleNewsPopUp = {
    Init: function () {
        const googleNewsPopUp = $('.gn-subscribe-popup');
        const jsPlayerDetach = $('.c-player.-sticky .detach-container.-detach.-foot-nav-detach');
        if (googleNewsPopUp !== undefined) {
            $(document).ready(function() {
                if (GoogleNewsPopUp.ShowGoogleNewsPopUp()) {
                    if (jsPlayerDetach !== undefined) {
                        jsPlayerDetach.css('bottom', googleNewsPopUp.children(1).height() + 75);
                    }
                    googleNewsPopUp.addClass('gn-show');
                }
            });
            googleNewsPopUp.find('button.gn-subscribe-popup-button[name="gnClose"]').on('click', function() {
                $.cookie(googleNewsPopUpClosed, true, { expires: 7 });
                googleNewsPopUp.removeClass('gn-show');
                jsPlayerDetach.css('bottom', 75);
            });
            googleNewsPopUp.find('button.gn-subscribe-popup-button[name="gnSubscribe"]').on('click', function() {
                const googleNewsSubscribeUrl = $(this).data('url');
                if (googleNewsSubscribeUrl && googleNewsSubscribeUrl.length > 0) {
                    localStorage.setItem(googleNewsStorage, true);
                    googleNewsPopUp.removeClass('gn-show');
                    jsPlayerDetach.css('bottom', 75);
                    window.open(googleNewsSubscribeUrl, '_blank');
                }
            });
        }
    },
    ShowGoogleNewsPopUp: function () {
        return !(localStorage.getItem(googleNewsStorage) === true || $.cookie(googleNewsPopUpClosed));
    }
}

module.exports = GoogleNewsPopUp;
